<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل نوع عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/typeview">انواع العقارات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل نوع عقار</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="isLoading" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown me-2">
              <i class="bi bi-pencil-square me-2 text-brown"></i> عرض البيانات
            </h5>
            <div class="card shadow mb-4">
              <div class="text-center pt-3">
                <errorAlert v-if="hasError" :alertMessage= "message" />
              </div>
              <div v-if="success" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="form-group py-2">
                      <label>التصنيف:</label>
                      <div>{{ categoryList[category] }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="form-group py-2">
                      <label>الاسم - عربي:</label>
                      <div>{{ name }}</div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="form-group py-2">
                      <label>الاسم - إنجليزي:</label>
                      <div>{{ nameEn }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <img :src="MEDIA_URL+this.image" class="img-fluid" alt="">
                  </div>
                  <div class="col">
                    <div class="form-group py-2">
                      <label for="">الحاله :</label>
                      <div>{{ (status)? 'نشط' : 'غير نشط' }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="buildNumberField">
                        <i v-if="propertyFields.indexOf('buildNumber') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        رقم المبنى
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="floorsCountField">
                        <i v-if="propertyFields.indexOf('floorsCount') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        عدد الطوابق
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="floorNumberField">
                        <i v-if="propertyFields.indexOf('floorNumber') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        رقم الطابق
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="apartmentNumberField">
                        <i v-if="propertyFields.indexOf('apartmentNumber') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        رقم الشقة
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="roomsCountField">
                        <i v-if="propertyFields.indexOf('roomsCount') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        عدد الغرف
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="bathroomsField">
                        <i v-if="propertyFields.indexOf('bathrooms') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        عدد الحمامات
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="hallsField">
                        <i v-if="propertyFields.indexOf('halls') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        عدد الصالات
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="ageField">
                        <i v-if="propertyFields.indexOf('age') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        عمر العقار
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="propertyTypeField">
                        <i v-if="propertyFields.indexOf('propertyType') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        نوع الساكن - عزاب ، عوائل
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="saudiBuildingCodeField">
                        <i v-if="propertyFields.indexOf('saudiBuildingCode') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        مطابق لكود البناء السعودي
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="furnishedField">
                        <i v-if="propertyFields.indexOf('furnished') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        مؤثث (نعم او لا)
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3 pb-2">
                    <div class="form-check">
                      <label class="form-check-label" for="plotNumberField">
                        <i v-if="propertyFields.indexOf('plotNumber') != -1" class="fa-regular fa-circle-check"></i>
                        <i v-else class="fa-regular fa-circle-xmark"></i>
                        رقم قطعة الارض
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "TypeRead",
  data(){
    return {
      typeID: this.$route.params.key,
      loading: false,
      hasError: false,
      success: false,
      message: "",
      name: "",
      nameEn: "",
      status: true,
      image: "",
      isLoading: false,
      propertyFields: [],
      category: 'residential',
      categoryList: {
        residential: 'سكني', 
        commercial: 'تجاري', 
        agricultural: 'زراعي', 
      },
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods:{
    getData() {
      this.hasError = false;
      this.isLoading = true;
      this.$http.get(`/api/admin/propertyTypes/retrieve/${this.typeID}`).then(res => {
        // console.log(res);
        this.isLoading = false;
        this.name = res.data.propertyType.name;
        this.nameEn = res.data.propertyType.nameEn;
        this.category = res.data.propertyType.category;
        this.image = res.data.propertyType.icon;
        this.status = res.data.propertyType.isActive;
        this.propertyFields = res.data.propertyType.propertyFields;
      }).catch (err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
  },
  created() {
    this.getData();
  }
};
</script>
